import { defineMessages } from "react-intl";

export default defineMessages({
  "visibility.Published": {
    id: "visibility.Published",
    defaultMessage: "Published",
  },
  "visibility.Unpublished": {
    id: "visibility.Unpublished",
    defaultMessage: "Unpublished",
  },
  "visibility.Archived": {
    id: "visibility.Archived",
    defaultMessage: "Archived",
  },
});
